import { getUser } from "./index.js";

const getUserData = () => {
	const user = getUser();

	if (!user) return null;

	const cpf = user.national_id || user.custom?.nationalId || user["custom:nationalId"];
	const email = user.email;
	const username = user.username;

	return {
		cpf,
		username,
		email,
	};
};

const sendAntifraudeAnalysis = (action) => {
	const token = window.ANTIFRAUDE_TOKEN;
	if (!token || token === "") {
		return;
	}

	const sdkInstance = window.__antifraudeSDKInstance;
	if (!sdkInstance) {
		return;
	}

	const userData = getUserData();
	if (!userData) {
		return;
	}

	try {
		console.log("[Antifraude SDK]: Sending analysis");
		sdkInstance.setAction(action);
		sdkInstance.sendAnalisys({
			username: userData.username,
			email: userData.email,
			cpf: userData.national_id || userData.cpf,
			ref_id_geoloc: window.TENANT === 'mars' ? 'marsbet' : window.TENANT,
		});
	} catch (error) {
		console.error("[Antifraude SDK]: Failed to send analysis", error);
	}
};

export const sendSignin = () => sendAntifraudeAnalysis("signin");
export const sendSignup = () => sendAntifraudeAnalysis("signup");
export const sendDeposit = () => sendAntifraudeAnalysis("deposit");
export const sendWithdraw = () => sendAntifraudeAnalysis("withdraw");
export const sendCheck = () => sendAntifraudeAnalysis("check");
